import axios from 'axios';
import SumsubWebSdk from '@sumsub/websdk-react';
import { ErrorToast } from '../../components';

interface NoKyc {
  accessSDKToken: string;
}

export const NoKyc = ({ accessSDKToken }: NoKyc) => {
  const isIOS =
    typeof navigator !== 'undefined' &&
    /iPad|iPhone|iPod/.test(navigator.userAgent);

  if (!accessSDKToken) {
    return <div>Loading KYC...</div>;
  }

  return (
    <div
      style={{
        height: 'calc(100dvh - 180px)',
        minHeight: 560,
        overflowY: 'auto',
        WebkitOverflowScrolling: 'touch',
        paddingBottom: 50
      }}>
      <SumsubWebSdk
        accessToken={accessSDKToken}
        expirationHandler={async () => {
          const apiURL = process.env.REACT_APP_API_URL;
          const { data } = await axios.get(
            `${apiURL}/kyc/sumsub-direct/sdk-token`
          );

          return data.data.token;
        }}
        options={{
          addViewportTag: !isIOS,
          adaptIframeHeight: true
        }}
        config={{
          lang: 'en',
          theme: 'light'
        }}
        onMessage={(e: any) => console.log(e)}
        onError={(e: any) => ErrorToast(e.error)}
      />
    </div>
  );
};
